export default [
    {
        name: '关于我们',
        url: 'about'
    },
    {
        name: '联系我们',
        url: 'contact'
    },
    {
        name: '服务协议',
        url: 'serve'
    },
    {
        name: '声明',
        url: 'statement'
    },
    {
        name: '留言反馈',
        url: 'feedback'
    }
]
